import { render, staticRenderFns } from "./insertUsersOpeningBalance.vue?vue&type=template&id=5c1b268b&scoped=true"
import script from "./insertUsersOpeningBalance.vue?vue&type=script&lang=js"
export * from "./insertUsersOpeningBalance.vue?vue&type=script&lang=js"
import style0 from "./insertUsersOpeningBalance.vue?vue&type=style&index=0&id=5c1b268b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1b268b",
  null
  
)

export default component.exports